import { render, staticRenderFns } from "./DynamicTable.vue?vue&type=template&id=c4e96f54&scoped=true"
import script from "./DynamicTable.vue?vue&type=script&lang=js"
export * from "./DynamicTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e96f54",
  null
  
)

export default component.exports